import React from "react";
import MapContainer from "./Components/MapContainer";

export default function MapPage() {
  return <MapContainer />;
}


